<h1 mat-dialog-title>{{ title }}</h1>

@if (innerHTML) {
  <mat-dialog-content [innerHTML]="innerHTML"></mat-dialog-content>
}
@else {
  <mat-dialog-content>
    <p>{{ body }}</p>
  </mat-dialog-content>
}

<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onConfirm()">OK</button>
</mat-dialog-actions>
